/**
 * Flag conventions
 * [platform]-[flag-type]-[feature-name]
 *
 * Platform:
 *   - all: all platform
 *   - android: android only
 *   - ios: ios only
 *   - web: web only
 * Flag Type:
 *   - b: boolean
 *   - v: variant
 * Feature name:
 *   - name of the feature with dash as separator
 *
 * Example:
 *   - web-b-split-order
 *   - all-v-language
 */

export enum FeatureFlagKeys {
  SPLIT_ORDER = 'all-b-split-order-eligibility',
  VTO = 'all-b-volume-trigger-order-eligibility',
  FAST_ORDER = 'web-b-fast-trade-eligibility',
  TRAILING_STOP = 'web-b-trailing-stop-eligibility',
  DAY_TRADE = 'all-b-day-trade-eligibility',
  MARKET_ORDER = 'enable-market-order',
  FAST_ORDER_DUPLICATE_BIDOFFER = 'web-b-fast-trade-duplicate-bidoffer',
  BRACKET_ORDER = 'web-b-bracket-order-eligibility',
  PORTO_PERFORMANCE = 'web-b-porto-performance',

  CHARTBIT_MAINTENANCE = 'chartbit_maintenance',
  CHARTBIT_DEBUG = 'chartbit_debug',
  CHARTBIT_DISABLE_AUTOSAVE = 'chartbit_disable_autosave',
  CHARTBIT_IFRAME_LOGGING = 'chartbit_iframe_logging',
  CHARTBIT_TRADE_FROM_CHART = 'chartbit_trade_from_chart',
  CHARTBIT_LOG = 'chartbit-log',
  CHARTBIT_V29 = 'chartbit_v29',
  FORCE_BARS_PREV = 'force-bars-prev',

  TOP_STOCKS = 'all-b-top-stock-eligibility',
  DISABLE_DATE_BEFORE = 'disable-date-before',
  RUNNING_TRADE_CHART = 'all-b-running-trade-chart-eligibility',
  RUNNING_TRADE_CHART_FILTER = 'all-b-running-trade-chart-date-filter-eligibility',
  KEYSTAT_DIVIDEND = 'all-b-keystat-dividend',

  WEB_TRENDING_CHART = 'web-b-trending-chart',
  DATA_CHANGE_WARNING = 'enable-data-change-warning',

  IFA_TRANSACTION = 'all-b-ifa-transaction',
}
